import { createSlice } from "@reduxjs/toolkit";

import { UserState } from "./types";

export const initialUserState: UserState = {
  workingHours: {
    start: { hours: 8, minutes: 0 },
    end: { hours: 18, minutes: 0 },
  },
  workingDays: [1, 2, 3, 4, 5, 6],
};

export const { actions: userActions, reducer: userReducer } = createSlice({
  name: "user",
  initialState: initialUserState,
  reducers: {},
});
